import { 
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  ContentChild,
  TemplateRef,
  ElementRef,
  ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngxs/store';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

@Component({
  selector: 'app-gallery-container',
  templateUrl: './gallery-container.component.html',
  styleUrls: ['./gallery-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryContainerComponent implements OnInit {
  @ContentChild('galleryActions', { read: TemplateRef }) 
  @Input()
  galleryActionsTemplate: TemplateRef<ElementRef>;

  @ContentChild('galleryTags', { read: TemplateRef }) 
  @Input()
  galleryTagsTemplate: TemplateRef<ElementRef>;

  @Input()
  viewMode = GalleryViewMode.Cards;

  @Input()
  checkedResults: string[] = [];

  @Input()
  loading = false;

  @Input()
  selectLabel = 'Select';

  @Input()
  checkable = true;

  @Input()
  showActions = true;

  @Input()
  public get results(): BookmarkModel[] {
    return this._results;
  }
  public set results(value: BookmarkModel[]) {
    this._results = value;
    this.changeDetectorRef.markForCheck();
  }
  private _results: BookmarkModel[];

  @Output()
  selectBookmark = new EventEmitter<BookmarkModel>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    
  }

  handleSelect(result: BookmarkModel) {
    this.selectBookmark.emit(result);
  }
}
